/** Internal dependencies */
import { apiCall } from '../apiCall';
import { getCurrentFilters } from '../getCurrentFilters';

/**
 * Handler for load more buttons. Correctly checks for pagination attributes.
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {Event} e
 * @returns void
 */
export function handleLoadMore(e) {
    e.preventDefault();

    const parent = e.target.closest('[data-ct-rest]');

    if (!parent) {
        return;
    }

    const api = JSON.parse(parent.dataset.ctRest);
    let currentFilters = '';

    // update pagination
    const offset = parent.querySelector('.offset-posts');
    if (offset) {
        offset.value = parseInt(offset.value) + 6;
        currentFilters = getCurrentFilters(parent);
    }

    api.currentpage++;
    parent.dataset.ctRest = JSON.stringify(api);

    apiCall(parent, currentFilters, false, true);
}
